import React from 'react';

import { Title } from '@/components/Title';

interface Props {
  title: React.ReactNode;
}

export const PageHeading: React.FC<React.PropsWithChildren<Props>> = ({ title, children }) => (
  <header className="flex h-10 items-center gap-4">
    <Title as="h1" size="h1">
      {title}
    </Title>

    {children}
  </header>
);
